import packageJson from "../../../package.json";

export const allowMultiLanguage = true;
export const BE_BASE_URL = import.meta.env.VITE_BE_API_URL;
export const WS_BASE_URL = import.meta.env.VITE_WS_URL;
export const WS_PATH = import.meta.env.VITE_WS_PATH;
export const API_ENCRYPT_SECRET_KEY = "salt";
export const APP_VERSION = packageJson.version;
export const APP_NAME = packageJson.name;
export const APP_LOGO = {
  icon: {
    light: "/assets/images/logo.png",
    dark: "/assets/images/logo-white.png",
  },
  full: {
    light: "/assets/images/logo-with-name.png",
    dark: "/assets/images/logo-white-with-name.png",
  },
};

export const SCREEN_BREAKPOINT = {
  mobile: 615,
  tablet: 935,
};

export const TELEGRAM_BOT_QUERY_ID = "94fab46d7eb43040c4325a28813850fd";

// Date range cache expiry time in hours
export const DATE_RANGE_CACHE_EXPIRY_HOURS = 1;
